module.exports = __webpack_public_path__ + "img/music-school-icon5.409168cd.png";